import { render, staticRenderFns } from "./disbursement-sheet-details.vue?vue&type=template&id=6dc81b0c&scoped=true&"
import script from "./disbursement-sheet-details.vue?vue&type=script&lang=js&"
export * from "./disbursement-sheet-details.vue?vue&type=script&lang=js&"
import style0 from "./disbursement-sheet-details.vue?vue&type=style&index=0&id=6dc81b0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc81b0c",
  null
  
)

export default component.exports